// UserSettingsDrawer.jsx - نسخه نهایی با اتصال به AuthContext
import React, { useState, useRef, useEffect } from "react";
import "./UserSettingsDrawer.css";
import { useAuth } from "../../context/AuthContext";
import { useCoins } from "../../context/CoinContext";
import { useNavigate } from "react-router-dom"; // 🆕 اضافه شد

// 🔽 CHANGED: curriculum helpers برای dropdown پایه و رشته
import {
  GRADE_LIST,
  FIELD_LIST,
  needsField as curriculumNeedsField,
  normalizeFieldId as curriculumNormalizeField,
  getField as getFieldMeta,
} from "../../core/education/curriculum.js";
import { engine } from "../../core/books/storage.js";

const DEFAULT_AVATAR = "/avatars/avatar34.png";

export default function UserSettingsDrawer({ isOpen, onClose }) {
  const { user, updateUser, logout } = useAuth();
  const { coins, xp } = useCoins();
  const navigate = useNavigate(); // 🆕

  // ===== هماهنگ‌سازی تم با ناوبر =====
const [isDark, setIsDark] = useState(() => {
  try {
    // 🔧 FIX: خواندن از engine برای هماهنگی با sync
    return engine.getRaw('navbar2-drawer-dark') === '1';
  } catch {
    return false;
  }
});

useEffect(() => {
  // گوش دادن به تغییرات localStorage در تب‌های دیگه
  const handleStorage = (e) => {
    if (e.key === 'navbar2-drawer-dark') {
      setIsDark(e.newValue === '1');
    }
  };
  window.addEventListener('storage', handleStorage);

  // sync در همون تب (storage event فقط در تب‌های دیگه فراخوانی می‌شه)
const interval = setInterval(() => {
  try {
    // 🔧 FIX: استفاده از engine.getRaw
    const current = engine.getRaw('navbar2-drawer-dark') === '1';
    setIsDark((prev) => (prev !== current ? current : prev));
  } catch {}
}, 500);

  return () => {
    window.removeEventListener('storage', handleStorage);
    clearInterval(interval);
  };
}, []);

  // ===== داده‌های واقعی کاربر =====
  const currentUser = user || {
    id: "",
    firstName: "",
    lastName: "",
    username: "",
    phone: "",
    grade: "",
    coins: 0,
    xp: 0,
    role: "student",
    createdAt: "",
  };

  // ===== استیت‌های اصلی =====
  const [firstName, setFirstName] = useState(currentUser.firstName || "");
  const [lastName, setLastName] = useState(currentUser.lastName || "");
  const [userName, setUserName] = useState(`${firstName} ${lastName}`.trim() || currentUser.username || "کاربر");
  const [accountOpen, setAccountOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [editNameOpen, setEditNameOpen] = useState(false);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
  const [phoneConfirmOpen, setPhoneConfirmOpen] = useState(false);
  const [tempFirstName, setTempFirstName] = useState(firstName);
  const [tempLastName, setTempLastName] = useState(lastName);
  const menuRef = useRef(null);

  // ===== آواتار =====
// ✅ مستقیماً از کاربر خونده می‌شه — هرجا عوض بشه، اینجا هم عوض می‌شه
const selectedAvatar =
  (user?.avatar && String(user.avatar).trim()) || DEFAULT_AVATAR;

const [avatarModalOpen, setAvatarModalOpen] = useState(false);
const [tempAvatar, setTempAvatar] = useState(null);

  // ===== نام کاربری و رمز =====
  const [editUsernameOpen, setEditUsernameOpen] = useState(false);
  const [editPasswordOpen, setEditPasswordOpen] = useState(false);
  const [tempUsername, setTempUsername] = useState(currentUser.username || "");
  const [tempPassword, setTempPassword] = useState("");

  // ===== پایه تحصیلی =====
  const [gradeModalOpen, setGradeModalOpen] = useState(false);
  const [userGrade, setUserGrade] = useState(currentUser.grade || "");
  const [tempGrade, setTempGrade] = useState(userGrade);

  // 🔽 CHANGED: State رشته (فقط برای پایه‌های ۱۰-۱۲)
  const [userField, setUserField] = useState(currentUser.field || null);
  const [tempField, setTempField] = useState(userField);

  // ===== یادآور مطالعه =====
  const [studyReminderEnabled, setStudyReminderEnabled] = useState(
    currentUser.studyReminderEnabled === true
  );
  const [studyReminderModalOpen, setStudyReminderModalOpen] = useState(false);
  const [studyTimes, setStudyTimes] = useState(
    Array.isArray(currentUser.studyTimes) ? currentUser.studyTimes : []
  );

  // ===== همگام‌سازی با تغییرات کاربر =====
useEffect(() => {
  if (user) {
    setFirstName(user.firstName || "");
    setLastName(user.lastName || "");
    setUserName(`${user.firstName || ""} ${user.lastName || ""}`.trim() || user.username || "کاربر");
    setUserGrade(user.grade || "");
    setTempUsername(user.username || "");
    // ✅ خط setSelectedAvatar حذف شد — چون حالا مشتق‌شده است
    const normalizedField = user.field ? (curriculumNormalizeField(user.field) || null) : null;
    setUserField(normalizedField);
    setTempField(normalizedField);
    setStudyReminderEnabled(user.studyReminderEnabled === true);
    setStudyTimes(Array.isArray(user.studyTimes) ? user.studyTimes : []);
  }
}, [user]);

  // ===== توابع کمکی =====
  const updateTime = (index, newTime) => {
    const updated = [...studyTimes];
    updated[index] = newTime;
    setStudyTimes(updated);
  };

  const removeTime = (index) => {
    const updated = studyTimes.filter((_, i) => i !== index);
    setStudyTimes(updated);
    const newEnabled = updated.length > 0 ? studyReminderEnabled : false;
    if (updated.length === 0) setStudyReminderEnabled(false);
    // ✅ ذخیره در سرور
    updateUser({
      studyTimes: updated,
      studyReminderEnabled: newEnabled,
    });
  };

  const formatStudyTime = (time) => {
    if (!time) return "";
    const { hour, minute, period } = time;
    return `${hour}:${minute} ${period}`;
  };

  // ===== کلیک بیرون از منو =====
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  // ===== بستن همه مودال‌های داخلی =====
  const closeAllModals = () => {
    setAccountOpen(false);
    setMenuOpen(false);
    setEditNameOpen(false);
    setLogoutConfirmOpen(false);
    setPhoneConfirmOpen(false);
    setEditUsernameOpen(false);
    setEditPasswordOpen(false);
    setGradeModalOpen(false);
    setStudyReminderModalOpen(false);
    setAvatarModalOpen(false);
    setTempAvatar(null);
  };

  // ===== بستن کل پنل (با کلیک روی بک‌دراپ) =====
  const handleCloseSettings = () => {
    closeAllModals();
    onClose();
  };

  // ===== بستن فقط بک‌دراپ مودال‌های داخلی (بدون بستن پنل اصلی) =====
  const handleModalBackdropClick = () => {
    closeAllModals();
  };

  // ===== ذخیره نام =====
  const handleSaveName = () => {
    const newFirstName = tempFirstName.trim() || firstName;
    const newLastName = tempLastName.trim() || lastName;
    const updatedUser = {
      ...currentUser,
      firstName: newFirstName,
      lastName: newLastName,
    };
    updateUser(updatedUser);
    setFirstName(newFirstName);
    setLastName(newLastName);
    setUserName(`${newFirstName} ${newLastName}`.trim() || currentUser.username);
    setEditNameOpen(false);
  };

  // ===== ذخیره پایه تحصیلی (و رشته برای ۱۰-۱۲) =====
  const handleSaveGrade = () => {
    const newGrade = tempGrade || userGrade;
    if (!newGrade) {
      alert("لطفاً پایه تحصیلی را انتخاب کنید");
      return;
    }

    // 🔽 CHANGED: چک نیاز به رشته
    const needsF = curriculumNeedsField(newGrade);
    if (needsF && !tempField) {
      alert("لطفاً رشته تحصیلی را انتخاب کنید");
      return;
    }

    const updatedUser = {
      ...currentUser,
      grade: newGrade,
      // 🔽 CHANGED: برای ۱-۹ فیلد رو null می‌کنیم، برای ۱۰-۱۲ ذخیره می‌کنیم
      field: needsF ? tempField : null,
    };

    updateUser(updatedUser);
    setUserGrade(newGrade);
    setUserField(needsF ? tempField : null);
    setGradeModalOpen(false);
  };

  // ===== ذخیره نام کاربری =====
  const handleSaveUsername = () => {
    const newUsername = tempUsername.trim() || currentUser.username;
    const updatedUser = {
      ...currentUser,
      username: newUsername,
    };
    updateUser(updatedUser);
    setTempUsername(newUsername);
    setEditUsernameOpen(false);
  };

  // ===== ذخیره رمز عبور (فقط در localStorage ذخیره می‌شود) =====
  const handleSavePassword = () => {
    if (tempPassword.length < 4) {
      alert("رمز عبور باید حداقل ۴ کاراکتر باشد");
      return;
    }
    const updatedUser = {
      ...currentUser,
      password: tempPassword,
    };
    updateUser(updatedUser);
    setEditPasswordOpen(false);
  };

  // ===== خروج =====
  const handleLogout = () => {
    logout();
    // 🆕 استفاده از replace تا دکمه back کاربر رو به حالت لاگین برنگردونه
    navigate('/login', { replace: true });
  };

  // ===== آواتار =====
  const handleSaveAvatar = () => {
  if (!tempAvatar) return;

  // ✅ فقط در AuthContext ذخیره کن — selectedAvatar خودش آپدیت می‌شه
  updateUser({ avatar: tempAvatar });

  setTempAvatar(null);
  setAvatarModalOpen(false);
};

  if (!isOpen) return null;

return (
  <div className={`settings-ui ${isDark ? 'dark-mode' : ''}`}>
      {/* ===== پس‌زمینه تار پنل اصلی ===== */}
      <div className="settings-overlay" onClick={handleCloseSettings} />

      {/* ===== کارت شناور تنظیمات ===== */}
      <div className="settings-floating-card scale-in">
        <button className="settings-close-btn" onClick={handleCloseSettings}>
          ✕
        </button>

        <div className="settings-header">
          <div className="settings-title">
            <i className="fas fa-cog" style={{ marginLeft: "10px" }}></i>
            تنظیمات
          </div>
          <div className="settings-subtitle">کلیک برای ویرایش آواتار</div>
        </div>

        {/* ===== آواتار بزرگ و حرفه‌ای ===== */}
        <div className="settings-avatar-block">
          <div
            className="settings-avatar-wrapper"
            onClick={() => setAvatarModalOpen(true)}
          >
            <img
  src={selectedAvatar}
  className="settings-avatar"
  alt="avatar"
  onError={(e) => {
    // اگه فایل پیدا نشد، به پیش‌فرض برگرد
    if (e.currentTarget.src !== window.location.origin + DEFAULT_AVATAR) {
      e.currentTarget.src = DEFAULT_AVATAR;
    }
  }}
/>
            <div className="avatar-edit-overlay">
              <i className="fas fa-camera"></i>
              <span>ویرایش</span>
            </div>
          </div>
        </div>

        <hr className="settings-divider" />

        {/* ===== لیست آیتم‌ها ===== */}
        <div className="settings-list">

          <button className="settings-item" onClick={() => setAccountOpen(true)}>
            <i className="fas fa-user-circle"></i>
            <span>اطلاعات حساب</span>
            <i className="fas fa-chevron-left" style={{ marginRight: "auto", opacity: 0.3, fontSize: "14px" }}></i>
          </button>
                    <button
            className="settings-item"
            onClick={() => {
              setTempGrade(userGrade);
              setTempField(userField);
              setGradeModalOpen(true);
            }}
          >
            <i className="fas fa-graduation-cap"></i>
            <span>
              پایه تحصیلی
              {/* 🔽 CHANGED: نمایش خلاصه‌ی پایه و رشته */}
              {userGrade && (
                <span style={{ fontSize: "12px", opacity: 0.6, marginRight: 8 }}>
                  {userGrade}
                  {userField && ` • ${getFieldMeta(userField)?.shortTitle || userField}`}
                </span>
              )}
            </span>
            <i className="fas fa-chevron-left" style={{ marginRight: "auto", opacity: 0.3, fontSize: "14px" }}></i>
          </button>

          <div
            className="settings-item settings-item-row"
            onClick={() => {
              if (studyTimes.length === 0) {
                setStudyTimes([{ hour: "10", minute: "30", period: "بعد از ظهر" }]);
              }
              setStudyReminderModalOpen(true);
            }}
          >
            <i className="fas fa-bell"></i>
            <span className="settings-item-text">یادآور مطالعه روزانه</span>
            <div
              className={`toggle-wrapper ${studyReminderEnabled ? "on" : "off"}`}
              onClick={(e) => {
                e.stopPropagation();
                const next = !studyReminderEnabled;
                setStudyReminderEnabled(next);

                if (next && studyTimes.length === 0) {
                  const defaultTimes = [{ hour: "10", minute: "30", period: "بعد از ظهر" }];
                  setStudyTimes(defaultTimes);
                  setStudyReminderModalOpen(true);
                  // ✅ ذخیره‌ی پیش‌فرض در سرور
                  updateUser({
                    studyTimes: defaultTimes,
                    studyReminderEnabled: true,
                  });
                } else {
                  // ✅ ذخیره‌ی toggle در سرور
                  updateUser({ studyReminderEnabled: next });
                }
              }}
            >
              <div className="toggle-circle" />
            </div>
          </div>

{studyTimes.length > 0 && (
  <div className="study-times-row">
    {studyTimes.map((t, idx) => (
      <span key={idx} className="study-time-chip">
        <span className="chip-text">{formatStudyTime(t)}</span>
        <button
          type="button"
          className="chip-remove-btn"
          onClick={(e) => {
            e.stopPropagation();
            removeTime(idx);
          }}
          aria-label="حذف این ساعت"
        >
          ✕
        </button>
      </span>
    ))}
  </div>
)}


          <button className="settings-item">
            <i className="fas fa-headset"></i>
            <span>پشتیبانی : 09058972500</span>
            <i className="fas fa-chevron-left" style={{ marginRight: "auto", opacity: 0.3, fontSize: "14px" }}></i>
          </button>
        </div>

        <div className="settings-footer">
          <span>نسخه ۲.۱.۰</span>
          
          
        </div>
      </div>

      {/* ===== بک‌دراپ برای مودال‌های داخلی (با کلیک بسته می‌شوند) ===== */}
      {(accountOpen || editNameOpen || logoutConfirmOpen || phoneConfirmOpen || 
        editUsernameOpen || editPasswordOpen || gradeModalOpen || 
        studyReminderModalOpen || avatarModalOpen) && (
        <div className="modal-backdrop" onClick={handleModalBackdropClick} />
      )}

      {/* ===== مودال حساب کاربری ===== */}
      {accountOpen && (
        <div className="modal-center">
          <div className="account-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="account-modal-header">
              <button className="account-close-btn" onClick={closeAllModals}>
                ✕
              </button>
              <div className="account-title">👤 حساب کاربری</div>
            </div>
            <div className="account-section">
              <div className="account-row">
                <div className="account-label">نام و نام خانوادگی</div>
                <div className="account-name-wrapper">
                  <div className="account-name">{userName}</div>
                  <button
                    className="account-menu-btn"
                    onClick={() => setMenuOpen(!menuOpen)}
                  >
                    ⋮
                  </button>
                  {menuOpen && (
                    <div className="account-menu-dropdown fade-in" ref={menuRef}>
                      <button
                        className="account-menu-item"
                        onClick={() => {
                          setTempFirstName(firstName);
                          setTempLastName(lastName);
                          setEditNameOpen(true);
                          setMenuOpen(false);
                        }}
                      >
                        ✏️ ویرایش نام
                      </button>
                      <button
                        className="account-menu-item danger"
                        onClick={() => {
                          setLogoutConfirmOpen(true);
                          setMenuOpen(false);
                        }}
                      >
                        🚪 خروج از حساب
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div
                className="account-row clickable"
                onClick={() => setPhoneConfirmOpen(true)}
              >
                <div className="account-label">شماره موبایل</div>
                <div className="account-phone">{currentUser.phone || "ثبت نشده"}</div>
              </div>

              {/*<div
                className="account-row clickable"
                onClick={() => setEditUsernameOpen(true)}
              >
                <div className="account-label">نام کاربری</div>
                <div className="account-phone">{currentUser.username || "ثبت نشده"}</div>
              </div>

              <div
                className="account-row clickable"
                onClick={() => { setTempPassword(""); setEditPasswordOpen(true); }}
              >
                <div className="account-label">رمز عبور</div>
                <div className="account-phone">********</div>
              </div>*/}
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال ویرایش نام ===== */}
      {editNameOpen && (
        <div className="modal-center">
          <div className="small-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="small-modal-title">✏️ ویرایش نام</div>
            <input
              className="name-input"
              placeholder="نام"
              value={tempFirstName}
              onChange={(e) => setTempFirstName(e.target.value)}
              style={{ marginBottom: "8px" }}
            />
            <input
              className="name-input"
              placeholder="نام خانوادگی"
              value={tempLastName}
              onChange={(e) => setTempLastName(e.target.value)}
            />
            <div className="small-modal-actions">
              <button className="btn-secondary" onClick={() => setEditNameOpen(false)}>
                بازگشت
              </button>
              <button className="btn-primary" onClick={handleSaveName}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال ویرایش نام کاربری ===== */}
      {editUsernameOpen && (
        <div className="modal-center">
          <div className="small-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="small-modal-title">✏️ ویرایش نام کاربری</div>
            <input
              className="name-input"
              value={tempUsername}
              onChange={(e) => setTempUsername(e.target.value)}
            />
            <div className="small-modal-actions">
              <button className="btn-secondary" onClick={() => setEditUsernameOpen(false)}>
                بازگشت
              </button>
              <button className="btn-primary" onClick={handleSaveUsername}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال ویرایش رمز ===== */}
      {editPasswordOpen && (
        <div className="modal-center">
          <div className="small-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="small-modal-title">🔒 ویرایش رمز عبور</div>
            <input
              className="name-input"
              type="password"
              placeholder="رمز جدید"
              value={tempPassword}
              onChange={(e) => setTempPassword(e.target.value)}
            />
            <div className="small-modal-actions">
              <button className="btn-secondary" onClick={() => setEditPasswordOpen(false)}>
                بازگشت
              </button>
              <button className="btn-primary" onClick={handleSavePassword}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال پایه تحصیلی (با dropdown + رشته) ===== */}
      {gradeModalOpen && (
        <div className="modal-center">
          <div className="grade-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="grade-modal-header">
              <button className="grade-close-btn" onClick={() => setGradeModalOpen(false)}>
                ✕
              </button>
              <div className="grade-title">🎓 پایه تحصیلی</div>
            </div>
            <div className="grade-content">
              <div className="grade-label">پایه تحصیلی کاربر</div>
              <select
                className="grade-input"
                value={tempGrade}
                onChange={(e) => {
                  const newGrade = e.target.value;
                  setTempGrade(newGrade);
                  // 🔽 CHANGED: ریست رشته اگه پایه جدید نیازی به رشته نداره
                  if (!curriculumNeedsField(newGrade)) {
                    setTempField(null);
                  }
                }}
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: "1px solid rgba(255,255,255,0.15)",
                  background: "rgba(255,255,255,0.04)",
                  color: "inherit",
                  fontSize: "15px",
                  outline: "none",
                }}
              >
                <option value="">-- انتخاب پایه --</option>
                {GRADE_LIST.map((g) => (
                  <option key={g.id} value={g.title}>
                    {g.title}
                  </option>
                ))}
              </select>

              {/* 🔽 CHANGED: انتخاب رشته برای پایه‌های ۱۰-۱۲ */}
              {curriculumNeedsField(tempGrade) && (
                <>
                  <div className="grade-label" style={{ marginTop: 16 }}>
                    رشته تحصیلی
                  </div>
                  <select
                    className="grade-input"
                    value={tempField || ""}
                    onChange={(e) => setTempField(e.target.value || null)}
                    style={{
                      width: "100%",
                      padding: "12px 14px",
                      borderRadius: "12px",
                      border: "1px solid rgba(255,255,255,0.15)",
                      background: "rgba(255,255,255,0.04)",
                      color: "inherit",
                      fontSize: "15px",
                      outline: "none",
                    }}
                  >
                    <option value="">-- انتخاب رشته --</option>
                    {FIELD_LIST.map((f) => (
                      <option key={f.id} value={f.id}>
                        {f.title}
                      </option>
                    ))}
                  </select>
                </>
              )}
            </div>
            <div className="grade-actions">
              <button className="btn-secondary" onClick={() => setGradeModalOpen(false)}>
                بازگشت
              </button>
              <button className="btn-primary" onClick={handleSaveGrade}>
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال یادآور مطالعه ===== */}
      {studyReminderModalOpen && (
        <div className="modal-center">
          <div className="study-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="study-modal-header">
              <button className="study-close-btn" onClick={() => setStudyReminderModalOpen(false)}>
                ✕
              </button>
              <div className="study-title">⏰ یادآور مطالعه روزانه</div>
            </div>
            <div className="study-description">
              ساعت‌هایی رو که می‌خوای بهت یادآوری کنه انتخاب کن.
            </div>
            <div className="study-times-list">
              {studyTimes.map((time, index) => (
                <div key={index} className="study-time-row">
                  <button className="study-remove-btn" onClick={() => removeTime(index)}>
                    حذف
                  </button>
                  <div className="time-picker">
<div className="time-column">
                      <button
                        className="time-btn"
                        onClick={() => {
                          const m = (parseInt(time.minute) + 1) % 60;
                          updateTime(index, { ...time, minute: m.toString().padStart(2, "0") });
                        }}
                      >
                        ▲
                      </button>
                      <input
                        className="time-input"
                        value={time.minute}
                        onChange={(e) => {
                          let v = e.target.value.replace(/\D/g, "");
                          if (v.length > 2) v = v.slice(0, 2);
                          if (parseInt(v) > 59) v = "59";
                          updateTime(index, { ...time, minute: v.padStart(2, "0") });
                        }}
                      />
                      <button
                        className="time-btn"
                        onClick={() => {
                          const m = (parseInt(time.minute) - 1 + 60) % 60;
                          updateTime(index, { ...time, minute: m.toString().padStart(2, "0") });
                        }}
                      >
                        ▼
                      </button>
                    </div>
                    <div className="time-separator">:</div>
                    <div className="time-column">
                      <button
                        className="time-btn"
                        onClick={() => {
                          const h = (parseInt(time.hour) + 1) % 12 || 12;
                          updateTime(index, { ...time, hour: h.toString().padStart(2, "0") });
                        }}
                      >
                        ▲
                      </button>
                      <input
                        className="time-input"
                        value={time.hour}
                        onChange={(e) => {
                          let v = e.target.value.replace(/\D/g, "");
                          if (v.length > 2) v = v.slice(0, 2);
                          if (parseInt(v) > 12) v = "12";
                          if (parseInt(v) < 1) v = "01";
                          updateTime(index, { ...time, hour: v.padStart(2, "0") });
                        }}
                      />
                      <button
                        className="time-btn"
                        onClick={() => {
                          const h = (parseInt(time.hour) - 1 + 12) % 12 || 12;
                          updateTime(index, { ...time, hour: h.toString().padStart(2, "0") });
                        }}
                      >
                        ▼
                      </button>
                    </div>
                    
                    <div className="time-ampm">
                      <button
                        className={`ampm-btn ${time.period === "صبح" ? "active" : ""}`}
                        onClick={() => updateTime(index, { ...time, period: "صبح" })}
                      >
                        صبح
                      </button>
                      <button
                        className={`ampm-btn ${time.period === "بعد از ظهر" ? "active" : ""}`}
                        onClick={() => updateTime(index, { ...time, period: "بعد از ظهر" })}
                      >
                        بعد از ظهر
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {studyTimes.length < 3 && (
              <div className="study-add-wrapper">
                <button
                  className="study-add-btn"
                  onClick={() => {
                    setStudyTimes([...studyTimes, { hour: "10", minute: "30", period: "بعد از ظهر" }]);
                  }}
                >
                  +
                </button>
              </div>
            )}
            <div className="study-actions">
              <button className="btn-secondary" onClick={() => setStudyReminderModalOpen(false)}>
                بازگشت
              </button>
              <button
                className="btn-primary"
                onClick={() => {
                  const enabled = studyTimes.length > 0;
                  setStudyReminderEnabled(enabled);
                  setStudyReminderModalOpen(false);
                  // ✅ ذخیره در سرور (روی کاربر)
                  updateUser({
                    studyTimes: studyTimes,
                    studyReminderEnabled: enabled,
                  });
                }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال خروج ===== */}
      {logoutConfirmOpen && (
        <div className="modal-center">
          <div className="small-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="small-modal-title center">
              آیا از خروج از حساب خود اطمینان کامل دارید؟
            </div>
            <div className="small-modal-actions">
              <button className="btn-secondary" onClick={() => setLogoutConfirmOpen(false)}>
                بازگشت
              </button>
              <button className="btn-danger" onClick={handleLogout}>
                خروج
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال تغییر شماره ===== */}
      {phoneConfirmOpen && (
        <div className="modal-center">
          <div className="small-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="small-modal-title center">
              تغییر شماره به منزله خروج از حساب است.
              <br />
              اگر می‌خواهید خارج شوید، تأیید کنید.
            </div>
            <div className="small-modal-actions">
              <button className="btn-secondary" onClick={() => setPhoneConfirmOpen(false)}>
                بازگشت
              </button>
              <button className="btn-danger" onClick={handleLogout}>
                خروج
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== مودال آواتار (بزرگ و حرفه‌ای) ===== */}
      {avatarModalOpen && (
        <div className="modal-center">
          <div className="avatar-modal modal-scale-in" onClick={(e) => e.stopPropagation()}>
            <button
              className="avatar-close-btn"
              onClick={() => {
                setTempAvatar(null);
                setAvatarModalOpen(false);
              }}
            >
              ✕
            </button>

            <div className="avatar-modal-title">🖼️ انتخاب عکس پروفایل</div>

            <div className="avatar-circle">
              <img
  src={tempAvatar || selectedAvatar}
  alt="avatar"
  onError={(e) => {
    if (e.currentTarget.src !== window.location.origin + DEFAULT_AVATAR) {
      e.currentTarget.src = DEFAULT_AVATAR;
    }
  }}
/>
            </div>

            <div className="avatar-actions">
              {/*<label className="avatar-btn">
                📁 انتخاب از گالری
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const url = URL.createObjectURL(file);
                      setTempAvatar(url);
                    }
                  }}
                />
              </label>*/}
              <button 
                className="avatar-btn" 
                onClick={() => { 
                  closeAllModals();
                  onClose();
                  navigate('/avatars'); // 🆕 ناوبری درون‌برنامه‌ای
                }}
              >
                🎨 انتخاب آواتار
              </button>
            </div>

            {tempAvatar && (
              <div className="avatar-save-actions">
                <button className="btn-secondary" onClick={() => setTempAvatar(null)}>
                  بازگشت
                </button>
                <button className="btn-primary" onClick={handleSaveAvatar}>
                  ذخیره
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}